<div class="edit-profile-page container">
  <mtn-user-profile-form [parentForm]="form" [userProfile]="userProfile"></mtn-user-profile-form>
</div>
